import { formatValue } from "../../utils/formatValue.js";
function computeDropdownOptions(format, customOptions) {
  if (customOptions) {
    return generateOptionsFromValues(customOptions, format);
  }
  return generateOptionsFromValues(defaultOptionsByFormat[format], format);
}
function generateOptionsFromValues(values, format) {
  return values.map((value) => ({
    value,
    label: formatValue(value, format)
  }));
}
const s = 1;
const m = s * 60;
const h = m * 60;
const defaultOptionsByFormat = {
  ss: [5 * s, 10 * s, 15 * s, 30 * s, 45 * s, 60 * s],
  mm: [5 * m, 10 * m, 15 * m, 30 * m, 45 * m, 60 * m],
  hh: [1 * h, 2 * h, 3 * h, 4 * h, 6 * h, 8 * h, 12 * h, 24 * h],
  "hh:mm": generateDefaultHHMMOptions(),
  "hh:mm:ss": generateDefaultHHMMOptions()
};
function generateDefaultHHMMOptions() {
  const lastValidTimeOption = 24 * h;
  const nextValues = [];
  for (let time = 0; time <= lastValidTimeOption; time += 15 * m) {
    nextValues.push(time);
  }
  return nextValues;
}
export {
  computeDropdownOptions
};
//# sourceMappingURL=useDropdownOptions.js.map
